// extracted by mini-css-extract-plugin
var _1 = "ConnectExternalIdentity-module__container--AhoQG";
var _2 = "ConnectExternalIdentity-module__pageCenter--8QwsX";
export { _1 as "container", _2 as "pageCenter" }
